import { Megaphone, UserRound } from "lucide-react";
import { useRoleStore } from "@/shared/store/role";
import { useBloggersWithPlacements } from "@/shared/api/wb";

/** Shown once per browser (persisted via useRoleStore) — this is a demo
 * prototype, not a real login, so "choosing a role" just picks which side
 * of the same session's data to render. See blogger_portal.py's docstring
 * for why there's no real blogger auth here. */
export function RoleStartupModal() {
  const role = useRoleStore((s) => s.role);
  const setRole = useRoleStore((s) => s.setRole);
  const setActiveBloggerId = useRoleStore((s) => s.setActiveBloggerId);
  const { data: bloggers } = useBloggersWithPlacements();

  if (role !== null) return null;

  function chooseBlogger() {
    setActiveBloggerId(bloggers?.[0]?.id ?? null);
    setRole("blogger");
  }

  return (
    <div className="fixed inset-0 z-[200] grid place-items-center" style={{ background: "rgba(28,28,28,0.55)", backdropFilter: "blur(6px)" }}>
      <div className="bg-white rounded-xl shadow-2xl fade-up p-7" style={{ width: "min(520px, 92vw)" }}>
        <div className="text-[11px] font-display font-semibold uppercase tracking-[0.16em] text-ink-40 mb-1.5">Прототип</div>
        <h2 className="font-display font-extrabold text-[22px] tracking-tight mb-1.5">Какой кабинет показываем?</h2>
        <p className="text-[13.5px] text-ink-60 leading-relaxed mb-6">
          Оба кабинета работают с одними и теми же данными — переключаться между ними можно в любой момент через шапку.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={() => setRole("advertiser")}
            className="flex flex-col items-center gap-2.5 p-5 rounded-xl border-2 border-ink-12 hover:border-ink transition-colors text-center"
          >
            <div className="w-11 h-11 rounded-full bg-ink text-white grid place-items-center"><Megaphone size={20} /></div>
            <div className="font-display font-bold text-[15px]">Рекламодатель</div>
            <div className="text-[11.5px] text-ink-40 leading-snug">Кампании, каталог блогеров, оплата</div>
          </button>
          <button
            onClick={chooseBlogger}
            className="flex flex-col items-center gap-2.5 p-5 rounded-xl border-2 border-ink-12 hover:border-ink transition-colors text-center"
          >
            <div className="w-11 h-11 rounded-full bg-lime text-[var(--fg-on-accent)] grid place-items-center"><UserRound size={20} /></div>
            <div className="font-display font-bold text-[15px]">Блогер</div>
            <div className="text-[11.5px] text-ink-40 leading-snug">Входящие заявки, отчёты, баланс</div>
          </button>
        </div>
      </div>
    </div>
  );
}
